import { Injectable } from '@angular/core';
import { Account, AccountRole, RawAccountRole, User } from '../models/auth.model';
import { ProfileResponse } from './auth-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthProfileMapper {
  map(response: ProfileResponse): User {
    const accounts = this.mapAccounts(response);
    const rawRoles = this.mapRawRoles(response, accounts);
    const accountRoles = this.mapAccountRoles(rawRoles);

    return {
      userId: response.user.userId,
      email: response.user.email,
      accountRoles,
      accounts
    };
  }

  private mapAccounts(response: ProfileResponse): Account[] {
    return (response.user.accounts ?? []).map((account) => ({
      accountId: account.accountId,
      name: account.name,
      ownerId: account.ownerId,
      updatedAt: account.updatedAt
    }));
  }

  private mapRawRoles(response: ProfileResponse, accounts: Account[]): RawAccountRole[] {
    return (response.user.roles ?? []).map((role) => ({
      accountRoleId: role.accountRoleId,
      accountId: role.accountId,
      roleName: role.roleName,
      userAccepted: role.userAccepted,
      accountAccepted: role.accountAccepted,
      isOwner: accounts.some((account) => account.accountId === role.accountId && account.ownerId === response.user.userId)
    }));
  }

  private mapAccountRoles(roles?: RawAccountRole[]): AccountRole[] {
    if (!roles) {
      return [];
    }

    return roles
      .map((role) => ({
        accountRoleId: role.accountRoleId,
        accountId: role.accountId ?? '',
        role: role.role ?? role.roleName ?? '',
        approved: role.approved ?? ((role.userAccepted ?? false) && (role.accountAccepted ?? false)),
        isOwner: role.isOwner ?? false
      }))
      .filter((role) => !!role.accountId);
  }
}
